import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CheckoutContext } from './CheckoutContext';
import { checkoutSettingsApi } from '../../api/checkout_settings';
import { RootState } from '../../rootReducer';
import { CheckoutSettings } from '../../interfaces/checkout_settings';
import { useAppDispatch } from '../../store';
import {
  setCheckouts,
  setCurrentCheckoutSetting,
} from '../../features/checkout/checkout';
import { useParams } from '../../navigation';

export const CheckoutProvider = ({ children }) => {
  const [currentCheckout, setCurrentCheckout] = useState(null);
  const checkoutSettings = useSelector<RootState, CheckoutSettings[]>(
    state => state.checkout.checkout_settings,
  );
  const { r_id } = useParams();
  const qrCode = useSelector<RootState, string | null>(
    state => state.cart.qr_code,
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const settings = await checkoutSettingsApi.getCheckoutSettings(
          parseInt(r_id),
          qrCode,
        );
        dispatch(setCheckouts(settings.data));

        // Choose the appropriate checkout setting here.
        // For example, let's assume we pick the first one for now.
        const appropriateSetting =
          settings.data.filter(s =>
            s.applicable_qr_codes.map(r => r.unique_id).includes(qrCode),
          ).length !== 0
            ? settings.data.filter(s =>
                s.applicable_qr_codes.map(r => r.unique_id).includes(qrCode),
              )[0]
            : null;
        setCurrentCheckout(appropriateSetting);
        dispatch(setCurrentCheckoutSetting(appropriateSetting));
      } catch (error) {
        console.error('Could not fetch checkout settings', error);
      }
    };

    fetchData();
  }, [qrCode, dispatch]);

  return (
    <CheckoutContext.Provider value={currentCheckout}>
      {children}
    </CheckoutContext.Provider>
  );
};
